<template>
  <div>
    <el-card>
      <el-table stripe border :data="list">
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="account"
          label="用户昵称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[5, 10, 20, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handelSizeChange"
        @current-change="handelPage"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { getUserList } from "@/api";
export default {
  name: "User",
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogFormVisible: false,
      type: 1, //1添加 2编辑
      form: {},
    };
  },
  mounted() {
    this.handleGetUserList();
  },
  methods: {
    handleGetUserList() {
      let formData = new FormData();
      formData.append("page", this.page);
      formData.append("size", this.pageSize);
      getUserList(formData).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    handelPage(val) {
      this.page = val;
      this.handleGetUserList();
    },
    handelSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.handleGetUserList();
    },
  },
};
</script>

<style></style>
